var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.25,
    height: 13.231,
    viewBox: "0 0 18.25 13.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0 -23.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14840",
    "data-name": "Group 14840",
    transform: "translate(0 34.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14839",
    "data-name": "Group 14839",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 18.25,
    height: 2.281,
    fill: "#333537"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14842",
    "data-name": "Group 14842",
    transform: "translate(0 28.808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14841",
    "data-name": "Group 14841",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 18.25,
    height: 2.281,
    fill: "#333537"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14844",
    "data-name": "Group 14844",
    transform: "translate(0 23.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14843",
    "data-name": "Group 14843",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 18.25,
    height: 2.281,
    fill: "#333537"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.cccee93a90532842817eba961edefb21.svg";
export { ForwardRef as ReactComponent };